import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './global_purged.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'

ReactDOM.createRoot(
  document.getElementById("root"),
)
.render(
    <AuthProvider>
      <App />
    </AuthProvider>
)
// Disabled strict mode because react-tooltip doesn't work with it... Temmporary fix
// .render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
// );
